import type { ReceiveSocketEventBasePayload, SendSocketEventBasePayload } from './socket.types';

/**
 * Base "Send" event types
 */

export enum SendSocketAuthEvents {
  AUTHORIZATION_RESPONSE = 'AUTHORIZATION_RESPONSE',
}

export type SendSocketAuthEventPayloadMap = {
  [SendSocketAuthEvents.AUTHORIZATION_RESPONSE]: SendSocketEventBasePayload<SendSocketAuthEvents.AUTHORIZATION_RESPONSE> & {
    authToken: string | null;
    adminToken: string | null;
    deviceToken: string | null;
    deviceType: 'SineWeb';
    teamId?: string;
  };
};

/**
 * Base "Receive" event types
 */

export enum ReceiveSocketAuthEvents {
  AUTHORIZATION_ERROR = 'AUTHORIZATION_ERROR',
  AUTHORIZATION_REQUEST = 'AUTHORIZATION_REQUEST',
  AUTHORIZATION_SUCCESS = 'AUTHORIZATION_SUCCESS',
  TOKEN_EXPIRED_CLOSED = 'TOKEN_EXPIRED_CLOSED',
  TOKEN_EXPIRED_ERROR = 'TOKEN_EXPIRED_ERROR',
}

export type ReceiveSocketAuthEventPayloadMap = {
  [ReceiveSocketAuthEvents.AUTHORIZATION_ERROR]: ReceiveSocketEventBasePayload<ReceiveSocketAuthEvents.AUTHORIZATION_ERROR>;
  [ReceiveSocketAuthEvents.AUTHORIZATION_REQUEST]: ReceiveSocketEventBasePayload<ReceiveSocketAuthEvents.AUTHORIZATION_REQUEST>;
  [ReceiveSocketAuthEvents.AUTHORIZATION_SUCCESS]: ReceiveSocketEventBasePayload<ReceiveSocketAuthEvents.AUTHORIZATION_SUCCESS>;
  [ReceiveSocketAuthEvents.TOKEN_EXPIRED_CLOSED]: ReceiveSocketEventBasePayload<ReceiveSocketAuthEvents.TOKEN_EXPIRED_CLOSED>;
  [ReceiveSocketAuthEvents.TOKEN_EXPIRED_ERROR]: ReceiveSocketEventBasePayload<ReceiveSocketAuthEvents.TOKEN_EXPIRED_ERROR>;
};
